import { IState } from '../StoreProvider/types'
import { Maybe } from '../../common/types'
import { JobFilters } from './types'

export const GetState = {
  filters: (state: IState): Maybe<JobFilters> => {
    return state.userPreferences && state.userPreferences.filters ? state.userPreferences.filters : null
  },
}
